import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Paper,
  Tab,
  Tabs,
  Typography,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Stack,
  Popover,
  GlobalStyles,
  // Chip,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import FilterListIcon from "@mui/icons-material/FilterList";
import DownloadIcon from "@mui/icons-material/Download";
import Cards from "../../ReusableComponents/Cards/Cards";
import StoreIcon from "@mui/icons-material/Store";
import CustomTable from "../../ReusableComponents/Table/CustomTable";
import PersonIcon from "@mui/icons-material/Person";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import CurrencyYenIcon from "@mui/icons-material/CurrencyYen";
import AddHomeIcon from "@mui/icons-material/AddHome";
import InventoryIcon from "@mui/icons-material/Inventory";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import api from "../../api/api";
import { DownloadCSV } from "../../ReusableComponents/DownloadCSV";
import en_ja from "../../translations/en_ja";
import BmiStatus from "../Dashboard/BmiStatus";
import bmi_image from '../../../src/assets/bmi_image.png';
import HealthAnswerStatus from "./HealthAnswerStatus";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
// import TotalClinicStatus from "./TotalClinicStatus";
// import TotalProductsPopup from "./TotalProductsPopup";
// import ProductWarrantyPopup from "./ProductWarrantyPopup";
// import TotalStoresPopup from "./TotalStoresPopup";
// import AllCardsPopup from "./AllCardsPopup";
// import RegistrationPopup from "./RegistrationPopup";
// import ActiveUsersPopup from "./ActiveUsersPopup";

export default function Reports() {
  const [cardsData, setCardsData] = useState({});
  const [userStats, setUserStats] = useState({});
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [clinicsData, setClinicsData] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const [ordersData, setOrdersData] = useState([]);
  const [storesData, setStoresData] = useState([]);
  const [tab, setTab] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [bmiCardData, setBmiCardData] = useState({});

  // FILTER STATE: only 'monthly' | 'range'
  const [filterMode, setFilterMode] = useState("monthly");
  const [monthYear, setMonthYear] = useState(""); // 'YYYY-MM'
  const [startDate, setStartDate] = useState(""); // 'YYYY-MM-DD'
  const [endDate, setEndDate] = useState(""); // 'YYYY-MM-DD'
  const [appliedFilters, setAppliedFilters] = useState(null);

  const [healthDialogOpen, setHealthDialogOpen] = useState(false);
  const [healthType, setHealthType] = useState(""); // answered | unanswered

  // const [activePopup, setActivePopup] = useState(null);

  // const [statsPopup, setStatsPopup] = useState({
  //   open: false,
  //   type: "",
  //   title: "",
  //   columns: [],
  // });

  // const appointmentsColumns = [
  //   {
  //     id: "user_name",
  //     label: en_ja["User Name"] ?? "User Name",
  //     sortable: true,
  //     render: (row) => {
  //       const first = row.user?.first_name;
  //       const last = row.user?.last_name;

  //       if (first || last) {
  //         return `${first ?? ""} ${last ?? ""}`;
  //       }

  //       return row.clinic_checkin_data?.full_name ?? "-";
  //     },
  //   },

  //   {
  //     id: "email",
  //     label: en_ja["Email"] ?? "Email",
  //     sortable: true,
  //     render: (row) =>
  //       row.user?.email ?? row.clinic_checkin_data?.email ?? "-",
  //   },

  //   {
  //     id: "phone",
  //     label: en_ja["Phone"] ?? "Phone",
  //     sortable: true,
  //     render: (row) => row.user?.phone_number ?? "-",
  //   },

  //   {
  //     id: "clinic_name",
  //     label: en_ja["Clinic"] ?? "Clinic",
  //     sortable: true,
  //     render: (row) => row.clinic?.clinic_name ?? "-",
  //   },

  //   {
  //     id: "consultation_type",
  //     label: en_ja["Consultation"] ?? "Consultation",
  //     sortable: true,
  //     render: (row) => row.consultation_type ?? "-",
  //   },

  //   {
  //     id: "appointment_date",
  //     label: en_ja["Appointment Date"] ?? "Appointment Date",
  //     sortable: true,
  //     render: (row) =>
  //       row.appointment_date
  //         ? new Date(row.appointment_date).toLocaleDateString("en-GB")
  //         : "-",
  //   },

  //   {
  //     id: "appointment_time",
  //     label: en_ja["Time"] ?? "Time",
  //     sortable: true,
  //   },

  //   {
  //     id: "status",
  //     label: en_ja["Status"] ?? "Status",
  //     sortable: true,
  //     render: (row) => {
  //       const status = (row.status || "").toLowerCase();

  //       let bgColor = "#6c757d";

  //       if (status === "completed") {
  //         bgColor = "#198754"; // green
  //       } else if (status === "confirmed") {
  //         bgColor = "#fd7e14"; // orange
  //       } else if (status === "closed") {
  //         bgColor = "#dc3545"; // red
  //       }

  //       return (
  //         <Chip
  //           label={row.status}
  //           size="small"
  //           sx={{
  //             backgroundColor: bgColor,
  //             color: "white",
  //             fontWeight: 600,
  //             fontSize: "10px",
  //             textTransform: "capitalize",
  //           }}
  //         />
  //       );
  //     },
  //   }
  // ];

  // const completedAppointmentsColumns = [
  //   {
  //     id: "user_name",
  //     label: en_ja["User Name"] ?? "User Name",
  //     sortable: true,
  //     render: (row) =>
  //       `${row.user?.first_name ?? ""} ${row.user?.last_name ?? ""}`,
  //   },

  //   {
  //     id: "email",
  //     label: en_ja["Email"] ?? "Email",
  //     sortable: true,
  //     render: (row) => row.user?.email ?? "-",
  //   },

  //   {
  //     id: "phone",
  //     label: en_ja["Phone"] ?? "Phone",
  //     sortable: true,
  //     render: (row) => row.user?.phone_number ?? "-",
  //   },

  //   {
  //     id: "clinic_name",
  //     label: en_ja["Clinic"] ?? "Clinic",
  //     sortable: true,
  //     render: (row) => row.clinic?.clinic_name ?? "-",
  //   },

  //   {
  //     id: "consultation_type",
  //     label: en_ja["Consultation Type"] ?? "Consultation Type",
  //     sortable: true,
  //     render: (row) => row.consultation_type ?? "-",
  //   },

  //   {
  //     id: "appointment_date",
  //     label: en_ja["Appointment Date"] ?? "Appointment Date",
  //     sortable: true,
  //     render: (row) =>
  //       row.appointment_date
  //         ? new Date(row.appointment_date).toLocaleDateString("en-GB")
  //         : "-",
  //   },

  //   {
  //     id: "appointment_time",
  //     label: en_ja["Time"] ?? "Time",
  //     sortable: true,
  //   },

  //   {
  //     id: "status",
  //     label: en_ja["Status"] ?? "Status",
  //     sortable: true,
  //     render: (row) => {
  //       const status = (row.status || "").toLowerCase();

  //       let bgColor = "#6c757d";

  //       if (status === "completed") {
  //         bgColor = "#198754"; // green
  //       } else if (status === "confirmed") {
  //         bgColor = "#fd7e14"; // orange
  //       } else if (status === "closed") {
  //         bgColor = "#dc3545"; // red
  //       }

  //       return (
  //         <Chip
  //           label={row.status}
  //           size="small"
  //           sx={{
  //             backgroundColor: bgColor,
  //             color: "white",
  //             fontWeight: 600,
  //             fontSize: "10px",
  //             textTransform: "capitalize",
  //           }}
  //         />
  //       );
  //     },
  //   }
  // ];

  // const prescriptionsColumns = [
  //   {
  //     id: "user_name",
  //     label: en_ja["User Name"] ?? "User Name",
  //     sortable: true,
  //     render: (row) =>
  //       `${row.user?.first_name ?? ""} ${row.user?.last_name ?? ""}`,
  //   },

  //   {
  //     id: "email",
  //     label: en_ja["Email"] ?? "Email",
  //     sortable: true,
  //     render: (row) => row.user?.email ?? "-",
  //   },

  //   {
  //     id: "phone",
  //     label: en_ja["Phone"] ?? "Phone",
  //     sortable: true,
  //     render: (row) => row.user?.phone_number ?? "-",
  //   },

  //   {
  //     id: "prescription_number",
  //     label: en_ja["Prescription ID"] ?? "Prescription ID",
  //     sortable: true,
  //   },

  //   {
  //     id: "clinic",
  //     label: en_ja["Clinic"] ?? "Clinic",
  //     sortable: true,
  //     render: (row) => row.appointment?.clinic?.clinic_name ?? "-",
  //   },

  //   {
  //     id: "medicine",
  //     label: en_ja["Medicine"] ?? "Medicine",
  //     sortable: false,
  //     render: (row) => row.medicines?.[0]?.name ?? "-",
  //   },

  //   {
  //     id: "total_amount",
  //     label: en_ja["Amount"] ?? "Amount",
  //     sortable: true,
  //     render: (row) => {
  //       const amount = row?.total_amount
  //       return (
  //         <span style={{ color: "#28a745", fontWeight: 600 }}>
  //           {amount ? `¥${Number(amount).toLocaleString()}` : "-"}
  //         </span>
  //       );
  //     }
  //   },

  //   {
  //     id: "prescription_date",
  //     label: en_ja["Date"] ?? "Date",
  //     sortable: true,
  //     render: (row) =>
  //       row.prescription_date
  //         ? new Date(row.prescription_date).toLocaleDateString("en-GB")
  //         : "-",
  //   },

  //   {
  //     id: "status",
  //     label: en_ja["Status"] ?? "Status",
  //     sortable: true,
  //     render: (row) => {
  //       const status = (row.status || "").toLowerCase();

  //       let bgColor = "#6c757d";

  //       if (status === "completed") bgColor = "#198754";
  //       else if (status === "pending") bgColor = "#fd7e14";
  //       else if (status === "cancelled") bgColor = "#dc3545";

  //       return (
  //         <Chip
  //           label={row.status}
  //           size="small"
  //           sx={{
  //             backgroundColor: bgColor,
  //             color: "white",
  //             fontWeight: 600,
  //             fontSize: "10px",
  //             textTransform: "capitalize",
  //           }}
  //         />
  //       );
  //     },
  //   },
  // ];

  // const prescriptionPaymentsColumns = [
  //   {
  //     id: "user_name",
  //     label: en_ja["User Name"] ?? "User Name",
  //     sortable: true,
  //     render: (row) =>
  //       row.user
  //         ? `${row.user?.first_name ?? ""} ${row.user?.last_name ?? ""}`
  //         : "-",
  //   },

  //   {
  //     id: "email",
  //     label: en_ja["Email"] ?? "Email",
  //     sortable: true,
  //     render: (row) => row.user?.email ?? "-",
  //   },

  //   {
  //     id: "phone",
  //     label: en_ja["Phone"] ?? "Phone",
  //     sortable: true,
  //     render: (row) => row.user?.phone_number ?? "-",
  //   },

  //   {
  //     id: "prescription_number",
  //     label: en_ja["Prescription ID"] ?? "Prescription ID",
  //     sortable: true,
  //     render: (row) => row.prescriptions?.[0]?.prescription_number ?? "-",
  //   },

  //   {
  //     id: "medicine",
  //     label: en_ja["Medicine"] ?? "Medicine",
  //     sortable: false,
  //     render: (row) => row.prescriptions?.[0]?.medicines?.[0]?.name ?? "-",
  //   },

  //   {
  //     id: "amount",
  //     label: en_ja["Amount"] ?? "Amount",
  //     sortable: true,
  //     render: (row) => {
  //       const amount = row?.amount
  //       return (
  //         <span style={{ color: "#28a745", fontWeight: 600 }}>
  //           {amount ? `¥${Number(amount).toLocaleString()}` : "-"}
  //         </span>
  //       );
  //     }
  //   },

  //   {
  //     id: "consultation_type",
  //     label: en_ja["Consultation"] ?? "Consultation",
  //     sortable: true,
  //     render: (row) => row.appointment?.consultation_type ?? "-",
  //   },

  //   {
  //     id: "appointment_date",
  //     label: en_ja["Appointment Date"] ?? "Appointment Date",
  //     sortable: true,
  //     render: (row) =>
  //       row.appointment?.appointment_date
  //         ? new Date(row.appointment.appointment_date).toLocaleDateString("en-GB")
  //         : "-",
  //   },

  //   {
  //     id: "status",
  //     label: en_ja["Status"] ?? "Status",
  //     sortable: true,
  //     render: (row) => {
  //       const status = row.prescriptions?.[0]?.status ?? "-";

  //       if (status === "-") return <span>-</span>;

  //       let bgColor = "#6c757d";
  //       if (status === "completed") bgColor = "#198754";
  //       else if (status === "pending") bgColor = "#fd7e14";
  //       else if (status === "cancelled") bgColor = "#dc3545";

  //       return (
  //         <Chip
  //           label={status}
  //           size="small"
  //           sx={{
  //             backgroundColor: bgColor,
  //             color: "white",
  //             fontWeight: 600,
  //             fontSize: "10px",
  //             textTransform: "capitalize",
  //           }}
  //         />
  //       );
  //     },
  //   }
  // ];

  // const ordersColumns = [
  //   {
  //     id: "order_id",
  //     label: en_ja["Order ID"] ?? "Order ID",
  //     sortable: true,
  //   },

  //   {
  //     id: "user_name",
  //     label: en_ja["Username"] ?? "Username",
  //     sortable: true,
  //     render: (row) =>
  //       `${row.user?.first_name ?? ""} ${row.user?.last_name ?? ""}`,
  //   },

  //   // {
  //   //   id: "product",
  //   //   label: en_ja["Product"] ?? "Product",
  //   //   sortable: false,
  //   //   render: (row) => {
  //   //     const product = row.orderProducts?.[0];

  //   //     return (
  //   //       <Box display="flex" alignItems="center" gap={1}>
  //   //         <img
  //   //           src={product?.product_image || "/placeholder.png"}
  //   //           alt="product"
  //   //           style={{
  //   //             width: 40,
  //   //             height: 40,
  //   //             borderRadius: 6,
  //   //             objectFit: "cover",
  //   //           }}
  //   //         />
  //   //         <Typography>
  //   //           {product?.product_name || "Product"}
  //   //         </Typography>
  //   //       </Box>
  //   //     );
  //   //   },
  //   // },

  //   {
  //     id: "created_at",
  //     label: en_ja["Date"] ?? "Date",
  //     sortable: true,
  //     render: (row) =>
  //       row.created_at
  //         ? new Date(row.created_at).toLocaleDateString("en-GB")
  //         : "-",
  //   },

  //   {
  //     id: "total_order_amount",
  //     label: en_ja["Order Total"] ?? "Order Total",
  //     sortable: true,
  //     render: (row) => {
  //       const amount = row.total_order_amount;

  //       return (
  //         <span style={{ color: "#28a745", fontWeight: 600 }}>
  //           {amount ? `¥${Number(amount).toLocaleString()}` : "-"}
  //         </span>
  //       );
  //     }
  //   }

  //   // {
  //   //   id: "payment",
  //   //   label: en_ja["Payment"] ?? "Payment",
  //   //   sortable: false,
  //   //   render: (row) => {
  //   //     const isPaid = row.total_order_amount > 0;

  //   //     return (
  //   //       <Typography
  //   //         sx={{
  //   //           color: isPaid ? "green" : "red",
  //   //           fontWeight: 500,
  //   //         }}
  //   //       >
  //   //         {isPaid ? "● Paid" : "Unpaid"}
  //   //       </Typography>
  //   //     );
  //   //   },
  //   // },

  //   // {
  //   //   id: "status",
  //   //   label: en_ja["Status"] ?? "Status",
  //   //   sortable: false,
  //   //   render: (row) => {
  //   //     const placed = row.total_order_amount > 0;

  //   //     return (
  //   //       <Typography color={placed ? "#6b7280" : "#ef4444"}>
  //   //         {placed ? "Order Placed" : "Order Not Placed"}
  //   //       </Typography>
  //   //     );
  //   //   },
  //   // },
  // ];

  // const orderPaymentsColumns = [
  //   {
  //     id: "order_id",
  //     label: en_ja["Order ID"] ?? "Order ID",
  //     sortable: true,
  //   },

  //   {
  //     id: "name",
  //     label: en_ja["Name"] ?? "Name",
  //     sortable: false,
  //     render: (row) =>
  //       `${row.user?.first_name ?? ""} ${row.user?.last_name ?? ""}`,
  //   },

  //   {
  //     id: "email",
  //     label: en_ja["Email"] ?? "Email",
  //     sortable: true,
  //     render: (row) => row.user?.email ?? "-",
  //   },

  //   {
  //     id: "phone_number",
  //     label: en_ja["Phone Number"] ?? "Phone Number",
  //     sortable: true,
  //     render: (row) => row.user?.phone_number ?? "-",
  //   },
  
  //   {
  //     id: "amount",
  //     label: en_ja["Amount"] ?? "Amount",
  //     sortable: true,
  //     render: (row) => {
  //       const amount = row?.amount
  //       return (
  //         <span style={{ color: "#28a745", fontWeight: 600 }}>
  //           {amount ? `¥${Number(amount).toLocaleString()}` : "-"}
  //         </span>
  //       );
  //     }
  //   },

  //   {
  //     id: "status",
  //     label: en_ja["Status"] ?? "Status",
  //     sortable: true,
  //     render: (row) => (
  //       <Chip
  //         label={row.status}
  //         size="small"
  //         sx={{
  //           backgroundColor:
  //             row.status === "COMPLETED"
  //               ? "#198754"
  //               : row.status === "FAILED"
  //                 ? "#dc3545"
  //                 : "#fd7e14",
  //           color: "white",
  //           fontWeight: 600,
  //           fontSize: "10px",
  //         }}
  //       />
  //     ),
  //   },

  //   {
  //     id: "created_at",
  //     label: en_ja["Payment Date"] ?? "Payment Date",
  //     sortable: true,
  //     render: (row) =>
  //       row.created_at
  //         ? new Date(row.created_at).toLocaleDateString("en-GB")
  //         : "-",
  //   },
  // ];

  // validation state
  const [dateError, setDateError] = useState("");

  // popover anchor
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const isFilterOpen = Boolean(filterAnchorEl);
  const handleOpenFilter = (e) => setFilterAnchorEl(e.currentTarget);
  const handleCloseFilter = () => {
    setFilterAnchorEl(null);
    setDateError(""); // clear errors when closing
  };

  // Build backend params (defensive)
  const buildFilterParams = (filters) => {
    if (!filters) return null;

    if (filters.mode === "monthly" && filters.monthYear) {
      const monthYearStr = String(filters.monthYear || "");
      const parts = monthYearStr.split("-");
      if (parts.length < 2) {
        console.warn("buildFilterParams: invalid monthYear:", filters.monthYear);
        return null;
      }
      const [year, monthStrRaw] = parts;
      if (!/^\d{4}$/.test(year) || !/^\d{1,2}$/.test(monthStrRaw)) {
        console.warn("buildFilterParams: invalid year/month:", filters.monthYear);
        return null;
      }
      const month = monthStrRaw.startsWith("0") ? monthStrRaw.slice(1) : monthStrRaw;
      return { month, year };
    }

    if (filters.mode === "range" && filters.startDate && filters.endDate) {
      return { start_date: filters.startDate, end_date: filters.endDate };
    }

    return null;
  };

  // API calls accept params
  const getAllCards = (params = null) => {
    const qs = params ? "?" + new URLSearchParams(params).toString() : "";
    api
      .get(`/v1/admin/AllStats${qs}`)
      .then((res) => setCardsData(res?.data?.data ?? {}))
      .catch((err) => console.error(err));
  };

  const getUserStats = (params = null) => {
    const qs = params ? "?" + new URLSearchParams(params).toString() : "";
    api
      .get(`/v1/admin/all/user-stats${qs}`)
      .then((res) => setUserStats(res?.data?.data ?? {}))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchAllData(null);
    fetchTableData();
  }, []);

  const fetchAllData = (params) => {
    getAllCards(params);
    getUserStats(params);
  };

  const fetchTableData = () => {
    getAllUsers();
    getAllClinics();
    getAllProducts();
    getAllOrders();
    getAllStores();
    getDashboardCards();
  };

  const getAllUsers = async () => {
    setLoading(true);
    try {
      const res = await api.get("/v1/admin/userStats");
      if (res) setUserData(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getAllClinics = async () => {
    setLoading(true);
    try {
      const res = await api.get("/v1/admin/clinic-stats");
      if (res) setClinicsData(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getAllProducts = async () => {
    setLoading(true);
    try {
      const res = await api.get("/v1/admin/product-stats");
      if (res) setProductsData(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getAllOrders = async () => {
    setLoading(true);
    try {
      const res = await api.get("/v1/admin/order-stats");
      if (res) setOrdersData(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getAllStores = async () => {
    setLoading(true);
    try {
      const res = await api.get("/v1/admin/store-stats");
      if (res) setStoresData(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleBmiCardClick = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const getDashboardCards = () => {
    api
      .get("/v1/admin/clinic-count")
      .then((res) => setBmiCardData(res?.data?.data ?? {}))
      .catch((err) => console.error(err));
  };

  const applyFilters = (filters) => {
    setAppliedFilters(filters);
    const params = buildFilterParams(filters);
    fetchAllData(params);
  };

  // --- dayjs helpers for pickers ---
  const handleMonthPickerChange = (newDayjs) => {
    if (!newDayjs) {
      setMonthYear("");
      setDateError("");
      return;
    }

    if (typeof newDayjs === "string") {
      const parsed = dayjs(newDayjs);
      if (!parsed.isValid()) {
        setDateError("");
        return;
      }
      newDayjs = parsed;
    }

    if (typeof newDayjs.isValid === "function" && !newDayjs.isValid()) {
      setMonthYear("");
      setDateError("");
      return;
    }

    if (newDayjs.isAfter(dayjs(), "month")) {
      setDateError("Selected month cannot be in the future");
      return;
    }

    setDateError("");
    const yyMm = newDayjs.format("YYYY-MM");
    setMonthYear(yyMm);
    applyFilters({ mode: "monthly", monthYear: yyMm });
  };

  // Range handlers using dayjs values from DatePicker
  const handleStartDateChange = (newDayjs) => {
    if (!newDayjs) {
      setStartDate("");
      setDateError("");
      return;
    }
    if (newDayjs.isAfter(dayjs(), "day")) {
      setDateError("Start date cannot be in the future");
      return;
    }
    const val = newDayjs.format("YYYY-MM-DD");

    if (endDate && dayjs(val).isAfter(dayjs(endDate), "day")) {
      setEndDate("");
      setStartDate(val);
      setDateError("");
      return;
    }

    setDateError("");
    setStartDate(val);
    if (val && endDate) applyFilters({ mode: "range", startDate: val, endDate });
  };

  const handleEndDateChange = (newDayjs) => {
    if (!newDayjs) {
      setEndDate("");
      setDateError("");
      return;
    }
    if (newDayjs.isAfter(dayjs(), "day")) {
      setDateError("End date cannot be in the future");
      return;
    }
    const val = newDayjs.format("YYYY-MM-DD");
    if (startDate && dayjs(startDate).isAfter(dayjs(val), "day")) {
      setDateError("End date cannot be before start date");
      setEndDate(val);
      return;
    }
    setDateError("");
    setEndDate(val);
    if (startDate && val) applyFilters({ mode: "range", startDate, endDate: val });
  };

  const handleClearFilters = () => {
    setFilterMode("monthly");
    setMonthYear("");
    setStartDate("");
    setEndDate("");
    setAppliedFilters(null);
    setDateError("");
    fetchAllData(null);
    handleCloseFilter();
  };

  const formatPrice = (amount) => {
    if (!amount && amount !== 0) return '-';
    if (amount === 0) return "¥0";
    return `¥${amount.toLocaleString()}`;
  };

  const TABLE_CONFIG = {
    Users: {
      title: en_ja["User Management"],
      columns: [
        { id: "name", label: en_ja["User Name"], sortable: true },
        { id: "email", label: en_ja["Email"], sortable: true },
        { id: "role", label: en_ja["Role"], sortable: true },
        { id: "totalOrders", label: en_ja["Total Orders"], sortable: true },
        { id: "totalSpent", label: en_ja["Total Spent"], sortable: true },
      ],
      rows: userData,
    },
    Clinics: {
      title: en_ja["Clinic Management"],
      columns: [
        { id: "clinic_name", label: en_ja["Clinic Name"], sortable: true },
        { id: "location", label: en_ja["Location"], sortable: true },
        { id: "patients", label: en_ja["Patients"], sortable: true },
        { id: "monthlyRevenue", label: en_ja["Monthly Revenue"], sortable: true },
        {
          id: "status",
          label: en_ja["Status"],
          sortable: true,
          render: (row) => (
            <Typography color={row.status ? "green" : "red"}>
              {row.status ? en_ja["Available"] : en_ja["Not Available"]}
            </Typography>
          ),
        },
      ],
      rows: clinicsData,
    },
    Products: {
      title: en_ja["Product Management"],
      columns: [
        { id: "productname", label: en_ja["Product Name"], sortable: true },
        {
          id: "price", label: en_ja["Price"], sortable: true,
          render: (row) => (
            <Typography fontSize="14px" fontWeight="600" color="#28a745">
              {formatPrice(row.price)}
            </Typography>
          )
        },
        { id: "sold", label: en_ja["Sold"], sortable: true },
        { id: "rating", label: en_ja["Rating"], sortable: true },
        {
          id: "status",
          label: en_ja["Status"],
          sortable: true,
          render: (row) => (
            <Typography color={row.status ? "green" : "red"}>
              {row.status ? en_ja["Available"] : en_ja["Not Available"]}
            </Typography>
          ),
        },
      ],
      rows: productsData,
    },
    Stores: {
      title: en_ja["Store Management"],
      columns: [
        { id: "storeName", label: en_ja["Store Name"], sortable: true },
        { id: "location", label: en_ja["Location"], sortable: true },
        { id: "revenue", label: en_ja["Revenue"], sortable: true },
        {
          id: "status",
          label: en_ja["Status"],
          sortable: true,
          render: (row) => (
            <Typography color={row.status ? "green" : "red"}>
              {row.status ? en_ja["Active"] : en_ja["InActive"]}
            </Typography>
          ),
        },
      ],
      rows: storesData,
    },
    Orders: {
      title: en_ja["Order Management"],
      columns: [
        { id: "order_id", label: en_ja["Order ID"], sortable: true },
        {
          id: "total_order_amount", label: en_ja["Total Amount"], sortable: true,
          render: (row) => (
            <Typography fontSize="14px" fontWeight="600" color="#28a745">
              {formatPrice(row.total_order_amount)}
            </Typography>
          )
        },
        {
          id: "orderdate",
          label: en_ja["Order Date"],
          sortable: true,
          render: (row) => {
            return (
              <Typography>
                {new Date(row.orderdate).toLocaleDateString('en-GB')}
              </Typography>
            );
          },
        },
        { id: "paymentMethod", label: en_ja["Payment Method"], sortable: true },
        {
          id: "paymentStatus",
          label: en_ja["Payment Status"],
          sortable: true,
          render: (row) => {
            const paidStatuses = ['COMPLETED', 'AUTHORIZED'];
            const isPaid = paidStatuses.includes(row.paymentStatus);

            return (
              <Typography color={isPaid ? 'green' : 'red'}>
                {isPaid ? en_ja['Paid'] : en_ja['Unpaid']}
              </Typography>
            );
          },
        }
      ],
      rows: ordersData,
    },
  };

  const TABS = Object.keys(TABLE_CONFIG);
  const handleTabChange = (e, newValue) => setTab(newValue);
  const activeTab = TABS[tab];
  const { title, columns, rows } = TABLE_CONFIG[activeTab];

  const formatCurrency = (amount) => `¥${Number(amount ?? 0).toLocaleString()}`;

  const buildCardsCSVRows = () => [
    { metric: en_ja["Number of Registrations"] ?? "Number of Registrations", value: userStats?.total_registrations ?? 0 },
    { metric: en_ja["Number of users who completed health questions"] ?? "Number of users who completed health questions", value: userStats?.users_completed_health_answers ?? 0 },
    { metric: en_ja["Number of Active Users"] ?? "Number of Active Users", value: userStats.active_users ?? 0 },
    { metric: en_ja["Number of Consultations booked"] ?? "Number of Consultations booked", value: userStats?.total_appointments ?? 0 },
    { metric: en_ja["Number of Consultations completed"] ?? "Number of Consultations completed", value: userStats?.completed_appointments ?? 0 },
    { metric: en_ja["Number of Prescriptions"] ?? "Number of Prescriptions", value: userStats?.total_prescriptions ?? 0 },
    { metric: en_ja["Total Prescription Amount value"] ?? "Total Prescription Amount value", value: formatCurrency(userStats?.total_prescription_amount) },
    { metric: en_ja["Number of Retails orders"] ?? "Number of Retails orders", value: userStats?.total_retail_orders ?? 0 },
    { metric: en_ja["Number of Total Retail sales"] ?? "Number of Total Retail sales", value: formatCurrency(userStats?.total_retail_orders_sales) },
    { metric: en_ja["Number of Retail Product Warranty Registrations"] ?? "Number of Retail Product Warranty Registrations", value: userStats?.total_product_warranty_registartions ?? 0 },
    { metric: en_ja["Total Clinics"] ?? "Total Clinics", value: cardsData.total_clinics ?? 0 },
    { metric: en_ja["Total Products"] ?? "Total Products", value: cardsData.total_products ?? 0 },
    { metric: en_ja["Total Stores"] ?? "Total Stores", value: cardsData.total_stores ?? 0 },
    { metric: en_ja["High BMI Status"] ?? "High BMI Status", value: bmiCardData?.bmi_over_25_count ?? 0 },
    { metric: en_ja["Not Answered Health Questions"] ?? "Not Answered Health Questions", value: cardsData?.userHealthAnswerDetails?.unansweredUsers?.length ?? 0 },
  ];

  const handleDownloadAllCards = () => {
    const csvColumns = [
      { id: "metric", label: en_ja["Name"] ?? "Name" },
      { id: "value", label: en_ja["Value"] ?? "Value" },
    ];
    DownloadCSV(csvColumns, buildCardsCSVRows(), `${en_ja["All_Cards_Report"] ?? "All_Cards_Report"}`);
  };

  const pickerPopperProps = {
    disablePortal: false,
    sx: {
      zIndex: 1401,
      "& .MuiYearPicker-root": { paddingBottom: "50px" },
      "& .MuiYearCalendar-root, & .MuiMonthPicker-root, & .MuiCalendarPicker-root": {
        overflowY: "auto",
        maxHeight: "300px",
        boxSizing: "border-box",
        paddingBottom: "50px",
      },
      "& .MuiPickersYear-yearButton, & .MuiYearPicker-yearButton": {
        margin: "6px 8px",
      },
    },
  };

  // const handleClosePopup = () => {
  //   setActivePopup(null);
  // };

  return (
    <Box sx={{ mt: 2 }}>
      <GlobalStyles
        styles={{
          ".MuiPickersPopper-root": { zIndex: 1401 },
          ".MuiYearPicker-root, .MuiYearCalendar-root, .MuiMonthPicker-root": {
            paddingBottom: "80px",
          },
          ".MuiCalendarPicker-root, .MuiYearCalendar-root, .MuiMonthPicker-root": {
            maxHeight: "300px",
            overflowY: "auto",
            boxSizing: "border-box",
            paddingBottom: "50px",
          },
        }}
      />

      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2, gap: 1 }}>
        <Button variant="contained" color="primary" startIcon={<DownloadIcon />} onClick={handleDownloadAllCards}>
          {en_ja["Report"] ?? "Report"}
        </Button>

        <Button variant="outlined" startIcon={<FilterListIcon />} onClick={handleOpenFilter}>
          {en_ja["Filter"] ?? "Filter"}
        </Button>

        <Popover
          open={isFilterOpen}
          anchorEl={filterAnchorEl}
          onClose={handleCloseFilter}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          // keep popover in same DOM for accessibility but picker popper will portal out
          disablePortal={true}
          sx={{ zIndex: 1400 }}
          PaperProps={{
            sx: {
              width: 360,
              p: 2,
              borderRadius: 2,
              boxShadow: "0 8px 36px rgba(0,0,0,0.12)",
              zIndex: 1400,
              // make sure internal overflow doesn't hide pickers (pickers portal out anyway)
              overflow: "visible",
            },
          }}
        >
          {/* smaller heading */}
          <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
            {en_ja["Filter Type"] ?? "Filter Type"}
          </Typography>

          {/* Toggle with smaller text */}
          <ToggleButtonGroup
            value={filterMode}
            exclusive
            onChange={(e, val) => {
              if (!val) return;
              setFilterMode(val);
              setMonthYear("");
              setStartDate("");
              setEndDate("");
              setDateError("");
            }}
            aria-label="filter-mode"
            sx={{ mb: 2 }}
          >
            <ToggleButton value="monthly" sx={{ fontSize: "0.8rem", px: 2, py: 1 }}>
              {en_ja["MONTHLY"] ?? "MONTHLY"}
            </ToggleButton>
            <ToggleButton value="range" sx={{ fontSize: "0.8rem", px: 2, py: 1 }}>
              {en_ja["DATE RANGE"] ?? "DATE RANGE"}
            </ToggleButton>
          </ToggleButtonGroup>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            {filterMode === "monthly" && (
              <>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  {en_ja["Select Month"] ?? "Select Month"}
                </Typography>

                <DatePicker
                  views={["year", "month"]}
                  label={en_ja["Select Month"] ?? "Select Month"}
                  value={monthYear ? dayjs(`${monthYear}-01`) : null}
                  onChange={handleMonthPickerChange}
                  maxDate={dayjs()}
                  size={"small"}
                  slotProps={{
                    textField: {
                      size: "small",
                      fullWidth: true,
                      inputProps: { readOnly: true },
                      onPaste: (e) => e.preventDefault(),
                      className: "textField",
                    },
                    popper: pickerPopperProps,
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 38,
                      fontSize: "0.8rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.8rem",
                    },
                  }}
                />

                <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>
                  {appliedFilters && appliedFilters.mode === "monthly" && appliedFilters.monthYear
                    ? `${en_ja["Filter applied:"] ?? "Filter applied:"} ${appliedFilters.monthYear}`
                    : ""}
                </Typography>
              </>
            )}

            {filterMode === "range" && (
              <>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  {en_ja["Select Date Range"] ?? "Select Date Range"}
                </Typography>

                <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                  <DatePicker
                    label={en_ja["From"] ?? "From"}
                    value={startDate ? dayjs(startDate) : null}
                    onChange={handleStartDateChange}
                    format="YYYY/MM/DD"
                    maxDate={dayjs()}
                    slotProps={{
                      textField: {
                        fullWidth: false,
                        size: "small",
                        error: !!dateError && dateError.includes("Start"),
                        helperText: !!dateError && dateError.includes("Start") ? dateError : "",
                      },
                      popper: pickerPopperProps,
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />

                  <DatePicker
                    label={en_ja["To"] ?? "To"}
                    value={endDate ? dayjs(endDate) : null}
                    onChange={handleEndDateChange}
                    format="YYYY/MM/DD"
                    minDate={startDate ? dayjs(startDate) : undefined}
                    maxDate={dayjs()}
                    slotProps={{
                      textField: {
                        fullWidth: false,
                        size: "small",
                        error: !!dateError && (dateError.includes("End") || dateError.includes("before")),
                        helperText: !!dateError && (dateError.includes("End") || dateError.includes("before")) ? dateError : "",
                      },
                      popper: pickerPopperProps,
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </Stack>

                <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>
                  {appliedFilters && appliedFilters.mode === "range" && appliedFilters.startDate && appliedFilters.endDate
                    ? `${en_ja["Filter applied:"] ?? "Filter applied:"} ${appliedFilters.startDate} - ${appliedFilters.endDate}`
                    : ""}
                </Typography>
              </>
            )}
          </LocalizationProvider>

          {/* inline error */}
          {dateError && (
            <Typography variant="caption" color="error" sx={{ mb: 1 }}>
              {en_ja[dateError] ?? dateError}
            </Typography>
          )}

          {/* Only Clear Filters */}
          <Box sx={{ mt: 2 }}>
            <Button fullWidth variant="outlined" onClick={handleClearFilters}>
              {en_ja["Clear Filters"] ?? "Clear Filters"}
            </Button>
          </Box>

        </Popover>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(1, 1fr)",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
            lg: "repeat(4, 1fr)",
          },
          gap: 3,
          width: "100%",
          alignItems: "stretch",
        }}
      >

        {/* <Box onClick={() => setActivePopup("registrations")} sx={{ cursor: "pointer" }}> */}
        <Cards title={en_ja["Number of Registrations"] ?? "Number of Registrations"} value={userStats.total_registrations ?? 0} icon={<PersonAddIcon sx={{ color: "white", fontSize: 24 }} />} />
        {/* </Box> */}

        <Box
          onClick={() => {
            setHealthType("answered");
            setHealthDialogOpen(true);
          }}
          sx={{ cursor: "pointer" }}
        >
          <Cards title={en_ja["Number of users who completed health questions"] ?? "Number of users who completed health questions"} value={userStats?.users_completed_health_answers ?? 0} icon={<ContactEmergencyIcon sx={{ color: "white", fontSize: 24 }} />} />
        </Box>

        {/* <Box onClick={() => setActivePopup("activeUsers")} sx={{ cursor: "pointer" }}> */}
        <Cards title={en_ja["Number of Active Users"] ?? "Number of Active Users"} value={userStats.active_users ?? 0} icon={<PersonIcon sx={{ color: "white", fontSize: 24 }} />} />
        {/* </Box> */}

        {/* <Box
          onClick={() =>
            setStatsPopup({
              open: true,
              type: "appointments",
              title: en_ja["Consultations Booked"] ?? "Consultations Booked",
              columns: appointmentsColumns,
            })
          }
          sx={{ cursor: "pointer" }}
        > */}
        <Cards title={en_ja["Number of Consultations booked"] ?? "Number of Consultations booked"} value={userStats?.total_appointments ?? 0} icon={<RecordVoiceOverIcon sx={{ color: "white", fontSize: 24 }} />} />
        {/* </Box> */}

        {/* <Box
          onClick={() =>
            setStatsPopup({
              open: true,
              type: "completed_appointments",
              title: en_ja["Consultations Completed"] ?? "Consultations Completed",
              columns: completedAppointmentsColumns,
            })
          }
          sx={{ cursor: "pointer" }}
        > */}
        <Cards title={en_ja["Number of Consultations completed"] ?? "Number of Consultations completed"} value={userStats?.completed_appointments ?? 0} icon={<CheckCircleOutlineIcon sx={{ color: "white", fontSize: 24 }} />} />
        {/* </Box> */}

        {/* <Box
          onClick={() =>
            setStatsPopup({
              open: true,
              type: "prescriptions",
              title: en_ja["Prescriptions"] ?? "Prescriptions",
              columns: prescriptionsColumns,
            })
          }
          sx={{ cursor: "pointer" }}
        > */}
        <Cards title={en_ja["Number of Prescriptions"] ?? "Number of Prescriptions"} value={userStats?.total_prescriptions ?? 0} icon={<ReceiptLongIcon sx={{ color: "white", fontSize: 24 }} />} />
        {/* </Box> */}

        {/* <Box
          onClick={() =>
            setStatsPopup({
              open: true,
              type: "prescription_payments",
              title: en_ja["Prescription Amount"] ?? "Prescription Amount",
              columns: prescriptionPaymentsColumns,
            })
          }
          sx={{ cursor: "pointer" }}
        > */}
        <Cards title={en_ja["Total Prescription Amount value"] ?? "Total Prescription Amount value"} value={userStats?.total_prescription_amount ?? 0} prefix="¥" icon={<CurrencyYenIcon sx={{ color: "white", fontSize: 24 }} />} />
        {/* </Box> */}

        {/* <Box
          onClick={() =>
            setStatsPopup({
              open: true,
              type: "orders",
              title: en_ja["Orders"] ?? "Orders",
              columns: ordersColumns,
            })
          }
          sx={{ cursor: "pointer" }}
        > */}
        <Cards title={en_ja["Number of Retails orders"] ?? "Number of Retails orders"} value={userStats?.total_retail_orders ?? 0} icon={<ShoppingCartIcon sx={{ color: "white", fontSize: 24 }} />} />
        {/* </Box> */}

        {/* <Box
          onClick={() =>
            setStatsPopup({
              open: true,
              type: "order_payments",
              title: en_ja["Total Retail sales"] ?? "Total Retail sales",
              columns: orderPaymentsColumns,
            })
          }
          sx={{ cursor: "pointer" }}
        > */}
        <Cards title={en_ja["Number of Total Retail sales"] ?? "Number of Total Retail sales"} value={userStats?.total_retail_orders_sales ?? 0} prefix="¥" icon={<CurrencyYenIcon sx={{ color: "white", fontSize: 24 }} />} />
        {/* </Box> */}

        {/* <Box onClick={() => setActivePopup("warranty")} sx={{ cursor: "pointer" }}> */}
        <Cards title={en_ja["Number of Retail Product Warranty Registrations"] ?? "Number of Retail Product Warranty Registrations"} value={userStats?.total_product_warranty_registartions ?? 0} icon={<VerifiedOutlinedIcon sx={{ color: "white", fontSize: 24 }} />} />
        {/* </Box> */}

        {/* <Box onClick={() => setActivePopup("clinics")} sx={{ cursor: "pointer" }}> */}
        <Cards title={en_ja["Total Clinics"] ?? "Total Clinics"} value={cardsData.total_clinics ?? 0} icon={<AddHomeIcon sx={{ color: "white", fontSize: 24 }} />} />
        {/* </Box> */}

        {/* <Box onClick={() => setActivePopup("products")} sx={{ cursor: "pointer" }}> */}
        <Cards title={en_ja["Total Products"] ?? "Total Products"} value={cardsData.total_products ?? 0} icon={<InventoryIcon sx={{ color: "white", fontSize: 24 }} />} />
        {/* </Box> */}

        {/* <Box onClick={() => setActivePopup("stores")} sx={{ cursor: "pointer" }}> */}
        <Cards title={en_ja["Total Stores"] ?? "Total Stores"} value={cardsData.total_stores ?? 0} icon={<StoreIcon sx={{ color: "white", fontSize: 24 }} />} />
        {/* </Box> */}

        <Box onClick={handleBmiCardClick} sx={{ cursor: "pointer" }}>
          <Cards
            title={en_ja['High BMI Status'] ?? 'High BMI Status'}
            value={bmiCardData?.bmi_over_25_count ?? 0}
            icon={
              <Box
                component="img"
                src={bmi_image}
                alt="BMI Icon"
                sx={{ width: 32, height: 32, borderRadius: '50%', p: 0.5 }}
              />
            }
          />
        </Box>

        <Box
          onClick={() => {
            setHealthType("unanswered");
            setHealthDialogOpen(true);
          }}
          sx={{ cursor: "pointer" }}
        >
          <Cards
            title={en_ja["Not Answered Health Questions"] ?? "Not Answered Health Questions"}
            value={
              cardsData?.userHealthAnswerDetails?.unansweredUsers?.length ?? 0
            }
            icon={<HelpOutlineIcon sx={{ color: "white", fontSize: 24 }} />}
          />
        </Box>

      </Box>

      {/* CSV Download Button for active table */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", my: 3 }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<DownloadIcon />}
          onClick={() =>
            DownloadCSV(
              columns,
              rows,
              `${en_ja[activeTab] || activeTab}_レポート`
            )
          }
        >
          {en_ja[activeTab]}
        </Button>
      </Box>

      {/* Tabs */}
      <Paper elevation={0} sx={{ my: 3, p: 2, borderRadius: "16px", border: "1px solid #e9ecef", backgroundColor: "white" }}>
        <Tabs value={tab} onChange={handleTabChange} variant="fullWidth" sx={{ width: "100%", "& .MuiTabs-indicator": { display: "none" } }}>
          {TABS.map((tabLabel, index) => (
            <Tab
              key={index}
              label={
                <Typography fontWeight={tab === index ? 700 : 500} sx={{ textTransform: "none", fontSize: "0.95rem" }}>
                  {en_ja[tabLabel] ?? tabLabel}
                </Typography>
              }
            />
          ))}
        </Tabs>
      </Paper>

      <Typography variant="h6" sx={{ mb: 2 }}>
        {title}
      </Typography>

      <Card sx={{ backgroundColor: "#fff", borderRadius: "12px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", border: "1px solid rgba(0, 0, 0, 0.05)", overflow: "hidden" }}>
        <CustomTable columns={columns} rows={rows} loading={loading} resetTrigger={activeTab} />
      </Card>

      <BmiStatus
        dialogOpen={dialogOpen}
        onClose={handleDialogClose}
      />

      <HealthAnswerStatus
        open={healthDialogOpen}
        onClose={() => setHealthDialogOpen(false)}
        type={healthType}
        data={cardsData}
      />

      {/* <TotalClinicStatus
        open={activePopup === "clinics"}
        onClose={handleClosePopup}
      />

      <TotalProductsPopup
        open={activePopup === "products"}
        onClose={handleClosePopup}
      />

      <ProductWarrantyPopup
        open={activePopup === "warranty"}
        onClose={handleClosePopup}
      />

      <TotalStoresPopup
        open={activePopup === "stores"}
        onClose={handleClosePopup}
      />

      <RegistrationPopup
        open={activePopup === "registrations"}
        onClose={handleClosePopup}
      />

      <ActiveUsersPopup
        open={activePopup === "activeUsers"}
        onClose={handleClosePopup}
      />

      <AllCardsPopup
        open={statsPopup.open}
        onClose={() => setStatsPopup({ ...statsPopup, open: false })}
        apiType={statsPopup.type}
        title={statsPopup.title}
        columns={statsPopup.columns}
      /> */}

    </Box>
  );
}
